/* Duinadem — dn-cart-drawer.js
   Winkelwagen-lade. Werkt samen met:
   - sections/dn-cart-drawer.liquid (de HTML)
   - Dawn product-form.js (standaard productpagina's): gebruikt dezelfde
     methodes als Dawn's eigen cart-drawer, dus toevoegen opent deze lade.
   - np-product.js (bundelpagina's): roept window.DNCart.add() aan.
   Geen externe libraries. */
(function () {
  'use strict';

  if (customElements.get('cart-drawer')) return;

  var SECTION_ID = 'dn-cart-drawer';
  var SECTIONS = [SECTION_ID, 'cart-icon-bubble'];

  // Dawn's pop-upmelding zou anders voorrang krijgen op deze lade
  document.querySelectorAll('cart-notification').forEach(function (n) { n.remove(); });

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Er ging iets mis. Probeer het opnieuw.');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  class DnCartDrawer extends HTMLElement {
    connectedCallback() {
      // Verplaats naar <body> zodat de header-laag hem nooit kan afdekken
      // (niet in de thema-editor, want daar herlaadt Shopify de sectie zelf).
      var designMode = window.Shopify && window.Shopify.designMode;
      if (!designMode && this.parentElement !== document.body) {
        document.body.appendChild(this);
        return; // appendChild roept connectedCallback opnieuw aan
      }
      if (this._ready) return;
      this._ready = true;

      if (this.dataset.section) {
        SECTION_ID = this.dataset.section;
        SECTIONS = [SECTION_ID, 'cart-icon-bubble'];
      }

      this.panel = this.querySelector('.dn-cart__panel');
      this.inner = this.querySelector('[data-dn-inner]');

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this), true);

      var self = this;
      // Via het prototype, zodat andere cart-apps deze functies niet kunnen 'uitzetten'
      window.DNCart = {
        open: function () { DnCartDrawer.prototype.open.call(self); },
        close: function () { DnCartDrawer.prototype.close.call(self); },
        refresh: function (opts) { return self.refresh(opts); },
        add: function (items) { return self.add(items); }
      };

      // /cart stuurt door naar ?cart=open
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('cart') === 'open') {
          url.searchParams.delete('cart');
          window.history.replaceState({}, '', url.pathname + url.search + url.hash);
          DnCartDrawer.prototype.open.call(this);
          this.refresh();
        }
      } catch (e) { /* oude browser: niets doen */ }

      // Terug-knop (bfcache): winkelwagen kan veranderd zijn
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) self.refresh();
      });
    }

    /* ---------- Openen / sluiten ---------- */
    open() {
      if (!this.activeElement) this.activeElement = document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('dn-cart-lock');
      var self = this;
      setTimeout(function () {
        var btn = self.querySelector('.dn-cart__close');
        (btn || self.panel).focus({ preventScroll: true });
      }, 50);
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('dn-cart-lock');
      if (this.activeElement && this.activeElement.focus) {
        this.activeElement.focus({ preventScroll: true });
      }
      this.activeElement = null;
    }

    /* Klik op het winkelwagen-icoon of een /cart-link opent de lade */
    onDocumentClick(e) {
      var link = e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"], [data-dn-cart-open]');
      if (!link || this.contains(link)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      e.stopPropagation();
      this.activeElement = link;
      DnCartDrawer.prototype.open.call(this);
      this.refresh();
    }

    onKeydown(e) {
      if (e.key === 'Escape') { DnCartDrawer.prototype.close.call(this); return; }
      if (e.key !== 'Tab') return;
      var f = this.panel.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    onClick(e) {
      var t = e.target;

      if (t.closest('[data-dn-close]')) { DnCartDrawer.prototype.close.call(this); return; }

      var qtyBtn = t.closest('[data-dn-qty]');
      if (qtyBtn) {
        this.change(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.dnQty, 10) || 0);
        return;
      }

      var addOne = t.closest('[data-dn-add-variant]');
      if (addOne) {
        this.add([{ id: Number(addOne.dataset.dnAddVariant), quantity: 1 }]).catch(function () {});
        return;
      }

      var upsell = t.closest('[data-dn-upsell]');
      if (upsell) {
        var card = upsell.closest('[data-dn-upsell-card]');
        var sel = card ? card.querySelector('select') : null;
        var id = sel ? sel.value : upsell.dataset.variant;
        this.add([{ id: Number(id), quantity: 1 }]).catch(function () {});
        return;
      }

      var checkout = t.closest('[data-dn-checkout]');
      if (checkout) {
        checkout.style.opacity = '.7';
      }
    }

    /* ---------- Winkelwagen-acties ---------- */
    setBusy(on) {
      this.classList.toggle('is-busy', !!on);
    }

    showError(msg) {
      var el = this.querySelector('[data-dn-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }

    add(items) {
      var self = this;
      this.setBusy(true);
      return postJSON(ROOT + 'cart/add.js', {
        items: items,
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
        .then(function (data) {
          self.renderSections(data.sections);
          DnCartDrawer.prototype.open.call(self);
          self.announce();
          return data;
        })
        .catch(function (err) {
          if (self.classList.contains('is-open')) self.showError(err.message);
          throw err;
        })
        .finally(function () { self.setBusy(false); });
    }

    change(key, quantity) {
      var self = this;
      this.setBusy(true);
      return postJSON(ROOT + 'cart/change.js', {
        id: key,
        quantity: Math.max(0, quantity),
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
        .then(function (data) {
          self.renderSections(data.sections);
          self.announce();
        })
        .catch(function (err) {
          self.refresh().then(function () { self.showError(err.message); });
        })
        .finally(function () { self.setBusy(false); });
    }

    refresh(opts) {
      var self = this;
      return fetch(ROOT + '?sections=' + SECTIONS.join(','), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          self.renderSections(sections);
          if (opts && opts.open) DnCartDrawer.prototype.open.call(self);
        })
        .catch(function () { /* stil falen, oude inhoud blijft staan */ });
    }

    renderSections(sections) {
      if (!sections) return;

      if (sections[SECTION_ID]) {
        var fresh = parse(sections[SECTION_ID]).querySelector('[data-dn-inner]');
        if (fresh) this.inner.innerHTML = fresh.innerHTML;
      }

      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var doc = parse(sections['cart-icon-bubble']);
          var wrap = doc.querySelector('.shopify-section');
          bubble.innerHTML = wrap ? wrap.innerHTML : doc.body.innerHTML;
        }
      }
    }

    announce() {
      document.dispatchEvent(new CustomEvent('dn:cart:updated'));
    }

    /* ---------- Koppeling met Dawn product-form.js ----------
       Dawn zoekt naar <cart-drawer> en roept deze 3 methodes aan. */
    getSectionsToRender() {
      return SECTIONS.map(function (id) { return { id: id }; });
    }

    setActiveElement(el) {
      this.activeElement = el;
    }

    renderContents(parsedState) {
      if (parsedState && parsedState.sections) {
        this.renderSections(parsedState.sections);
      } else {
        this.refresh();
      }
      DnCartDrawer.prototype.open.call(this);
    }
  }

  customElements.define('cart-drawer', DnCartDrawer);
})();
